import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { Home } from 'lucide-react';

/**
 * Branded 404 page - renders inside MainLayout so it inherits
 * the tenant's header, footer and theme automatically.
 */
const NotFound = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { tenanturlname } = useParams();

  const handleBackHome = () => {
    navigate(`/${tenanturlname}`);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-16 text-center">
      {/* 404 number */}
      <div className="text-[96px] font-extrabold leading-none text-theme-primary select-none">
        404
      </div>

      {/* Title */}
      <h1 className="mt-4 text-lg font-bold text-theme-secondary max-w-sm">
        {t('notFound.title') || "Oops, we can't seem to find the page you are looking for"}
      </h1>

      {/* Back to Home button */}
      <Button
        type="button"
        variant="primary"
        onClick={handleBackHome}
        className="mt-8 w-full sm:w-auto rounded-full px-8 h-11 text-sm font-semibold flex items-center justify-center gap-2"
      >
        <Home className="w-4 h-4" />
        {t('notFound.backHome') || 'Back to Home'}
      </Button>
    </div>
  );
};

export default NotFound;
